import { render, staticRenderFns } from "./tags-data-item.vue?vue&type=template&id=d524194e&"
import script from "./tags-data-item.vue?vue&type=script&lang=js&"
export * from "./tags-data-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports